import type { DistrictArtAsset } from '../../NumberKingdomDistrictRegistry.js';

const ROOT = 'assets/number-kingdom/addition-citadel/regrouping-workshop';

/** Authoritative runtime registry for the validated production pack. */
export const REGROUPING_WORKSHOP_ASSETS = {
  workshopBackground: { key: 'regrouping-workshop-background', path: `${ROOT}/environment/regrouping-workshop-bg.png`, kind: 'image', required: true },
  workshopForeground: { key: 'regrouping-workshop-foreground', path: `${ROOT}/environment/regrouping-workshop-foreground.png`, kind: 'image', required: true },
  workshopDormant: { key: 'regrouping-workshop-dormant', path: `${ROOT}/environment/regrouping-workshop-dormant.png`, kind: 'image', required: true },
  workshopPowered: { key: 'regrouping-workshop-powered', path: `${ROOT}/environment/regrouping-workshop-powered.png`, kind: 'image', required: true },
  onePiece: { key: 'regrouping-workshop-one-piece', path: `${ROOT}/interactives/one-piece.png`, kind: 'image', required: true },
  tenPiece: { key: 'regrouping-workshop-ten-piece', path: `${ROOT}/interactives/ten-piece.png`, kind: 'image', required: true },
  onesChamber: { key: 'regrouping-workshop-ones-chamber', path: `${ROOT}/interactives/ones-chamber.png`, kind: 'image', required: true },
  tensChamber: { key: 'regrouping-workshop-tens-chamber', path: `${ROOT}/interactives/tens-chamber.png`, kind: 'image', required: true },
  selectionTray: { key: 'regrouping-workshop-selection-tray', path: `${ROOT}/interactives/regroup-selection-tray.png`, kind: 'image', required: true },
  regroupCoreDormant: { key: 'regrouping-workshop-core-dormant', path: `${ROOT}/interactives/regroup-core-dormant.png`, kind: 'image', required: true },
  regroupCorePowered: { key: 'regrouping-workshop-core-powered', path: `${ROOT}/interactives/regroup-core-powered.png`, kind: 'image', required: true },
  challengePanel: { key: 'regrouping-workshop-challenge-panel', path: `${ROOT}/ui/challenge-panel.png`, kind: 'image', required: true },
  regroupButton: { key: 'regrouping-workshop-regroup-button', path: `${ROOT}/ui/regroup-button.png`, kind: 'image', required: true },
  powerButton: { key: 'regrouping-workshop-power-button', path: `${ROOT}/ui/power-button.png`, kind: 'image', required: true },
  hintButton: { key: 'regrouping-workshop-hint-button', path: `${ROOT}/ui/hint-button.png`, kind: 'image', required: true },
  resetButton: { key: 'regrouping-workshop-reset-button', path: `${ROOT}/ui/reset-button.png`, kind: 'image', required: true },
  selectionGlow: { key: 'regrouping-workshop-selection-glow', path: `${ROOT}/vfx/ten-ones-selection-glow.png`, kind: 'image', required: true },
  regroupTransformation: { key: 'regrouping-workshop-transformation', path: `${ROOT}/vfx/regroup-transformation.png`, kind: 'image', required: true },
  newTenTransfer: { key: 'regrouping-workshop-new-ten-transfer', path: `${ROOT}/vfx/new-ten-transfer.png`, kind: 'image', required: true },
  workshopPowerBurst: { key: 'regrouping-workshop-power-burst', path: `${ROOT}/vfx/workshop-power-burst.png`, kind: 'image', required: true },
} as const satisfies Record<string, DistrictArtAsset>;

export const REGROUPING_WORKSHOP_ASSET_LIST = Object.values(REGROUPING_WORKSHOP_ASSETS);

export const REGROUPING_WORKSHOP_PRODUCTION_GATE = {
  routeEnabled: true,
  reason: 'production-assets-validated',
} as const;

export function preloadRegroupingWorkshopAssets(scene: Phaser.Scene) {
  REGROUPING_WORKSHOP_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingRegroupingWorkshopImages(textures: Phaser.Textures.TextureManager) {
  return REGROUPING_WORKSHOP_ASSET_LIST.filter(asset => asset.required && !textures.exists(asset.key));
}

export function isRegroupingWorkshopProductionReady(textures: Phaser.Textures.TextureManager) {
  return getMissingRegroupingWorkshopImages(textures).length === 0;
}

export function canEnterRegroupingWorkshop(textures: Phaser.Textures.TextureManager) {
  return REGROUPING_WORKSHOP_PRODUCTION_GATE.routeEnabled
    && isRegroupingWorkshopProductionReady(textures);
}
